import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import {App} from 'ionic-angular';
import {OauthService} from './oauth.service';
import {Http} from '@angular/http';
import {Search} from '../models/search/search.model';
import {Observable} from 'rxjs/Observable';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class PaymentService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);

    this.loader.next(true); // init custom loader
  }

  getPayment(idOrder) {
    // api_get_checkout_payment
    // const url = `${this.Routing.b.scheme}://${this.Routing.b.host}/api/checkout`;
    //
    // return this.http
    //   .get(`${url}/${idOrder}/payment.json`, {headers: this.updateHeaders()})
    //   .map(response => {
    //     this.loader.next(false); // enable custom loader
    //     return response.json().data;
    //   });
    const url = this.Routing.generate('api_get_checkout_payment', {'_format': 'json', 'cart': idOrder }, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
            this.loader.next(false); // enable custom loader
            return response.json().data;
      });
  }

  setPayment(dataPayment) {
    const url = this.Routing.generate('api_post_paiement_prepare', {'_format': 'json'}, true);
    let formData;
    let headerType;

    if ('uploadedFile' in dataPayment) {
      headerType = 'upload';
      formData = new FormData();
      for (const item in dataPayment) {
        if (item) {
          formData.append(item, dataPayment[item]);
        }
      }
    } else {
      headerType = 'formData';
      formData = this.getFormData(dataPayment);
    }

    return this.http
      .post(url, formData, {headers: this.updateHeaders(headerType)})
      .map(response => response.json());
  }

  doRequest(url: string) {
    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => response.json());
  }

  getAllPaiementsEncaissement(search: Observable<Search> = null) {
    return search.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(s => this.searchAllPaiementsEncaissement(s, s.action));
  }

  searchAllPaiementsEncaissement(search: Search, action: string) {
    const param = {'_format': 'json'};

    for (const item in search) {
      if (search[item]) {
        param[item] = search[item];
      }
    }

    const url = this.Routing.generate('api_get_paiements_encaissement', param, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false); // disable custom loader
        return {data: response.json().data, action};
      });
  }

  getMoyenPaiements() {
    const param = {'_format': 'json', };

    const url = this.Routing.generate('api_get_moyen-paiements', param, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false); // enable custom loader
        return response.json().data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/payment.service.ts